import {Injectable} from '@angular/core';

import {Router} from '@angular/router';
import {UserService} from '../modules/admin/services/user.service';


@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {

    public permissions: string[] = [];

    constructor(private userService: UserService,
                private router: Router) {

        this.permissions = [];
    }

    hasPermission(per: string) {

        let theprmissions = this.getPermissions();

        if (theprmissions == null) {
            return false;
        }

        for (var i = 0; i < theprmissions.length; i++) {
            // No internal logic is necessary.
            if (per === theprmissions[i]) {
                return true;
            }
        }

        return false;
    }


    loadUserPermissions(id): any {

        return this.userService.getUserPermissions(id);

    }

    setPermissions(permissions) {

        this.permissions = [];
        // fill in the permissions
        for (let i = 0; i < permissions.length; i++) {
            this.permissions.push(permissions[i].name);
        }

        // var enc_permissions = this.EncrDecr.set('123456$#@$^@1ERF', JSON.stringify(data));
        localStorage.setItem('p', JSON.stringify(this.permissions));


    }

    getPermissions() {

        /* if(localStorage.getItem('t') !== null && localStorage.getItem('t') !==''){
             this.getGuestPermissions();
         }else */
        if (this.permissions.length === 0) {

            // try get it from the local storage
            const data = localStorage.getItem('p');
            return JSON.parse(data);
        }

        return this.permissions;
    }

    fillDefaultPermissions() {
        this.permissions = ['view_home', 'view_features', 'view_contact_us', 'view_about', 'view_article'];

    }

    getGuestPermissions() {
        this.fillDefaultPermissions();
        return this.permissions;
    }


    requierPermission(permission) {


        if (!this.hasPermission(permission)) {

            // sorry , user not allowed to access page , show access denied
        //    this.router.navigateByUrl('/common/access_denied');
            this.router.navigate(['/common/access_denied'], {queryParams: {permission: permission}});

        } else {
            // all fine

        }

    }

    public getCurrentlyLoggedUser() {

        var current_user = JSON.parse(localStorage.getItem('current_user'));
        return current_user;
    }


}
